import { Box } from '@palmetto/palmetto-components';

import DirectPayVendorLabel from './DirectPayVendorLabel';
import EventBy from './EventBy';

const GATE_LABELS: Record<string, string> = {
  ntp: 'NTP',
  install: 'Install',
  shipmentConfirmation: 'shipment confirmation',
  finalizationInvoice: 'finalization invoice',
};

const DirectPaySupportOverride = ({ event }: { event: any }) => {
  const verb = event.data?.action === 'optOut' ? 'opt-out' : 'opt-in';
  const gates = (event.data?.bypassedGates ?? []).map((g: string) => GATE_LABELS[g] ?? g).join(' and ');

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> overrode Direct Pay {verb}
        <DirectPayVendorLabel alias={event.data?.directPayMaterialVendorAlias} />
        {gates ? ` (bypassed ${gates})` : ''}
      </Box>
      {event.data?.reason && (
        <Box display="block" fontSize="sm" color="body-secondary">
          Reason: {event.data.reason}
        </Box>
      )}
      {event.data?.salesforceTicketNumber && (
        <Box display="block" fontSize="sm" color="body-secondary">
          Salesforce ticket: {event.data.salesforceTicketNumber}
        </Box>
      )}
    </Box>
  );
};

export default DirectPaySupportOverride;
